import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { PollsService, ActivePoll } from '../../service/polls.service';
import { AuthService } from '../../../auth.service';

@Component({
    selector: 'app-voting-announcement-widget',
    standalone: true,
    imports: [CommonModule, RouterModule, ButtonModule],
    styleUrls: ['./announcement.component.scss'],
    template: `
        @if (activePolls.length) {
            <div class="announcement flex items-center justify-between gap-4 flex-wrap">
                <div>
                    <div class="announcement-title font-semibold mb-1">🗳️ Community-Voting läuft!</div>
                    <div class="announcement-text">
                        Stimme jetzt ab:
                        <span class="announcement-highlight">{{ pollTitles }}</span>
                        @if (soonestDays !== null) { · endet in {{ soonestDays }} Tag(en) }
                    </div>
                </div>
                <a routerLink="/pages/voting">
                    <p-button label="Jetzt abstimmen" icon="pi pi-thumbs-up" />
                </a>
            </div>
        }
    `,
})
export class VotingAnnouncementWidget implements OnInit {
    activePolls: ActivePoll[] = [];
    pollTitles = '';
    soonestDays: number | null = null;

    constructor(private pollsService: PollsService, private authService: AuthService) {}

    ngOnInit(): void {
        if (!this.authService.isLoggedIn()) { return; }
        this.pollsService.getActivePolls().subscribe({
            next: (polls) => {
                this.activePolls = polls;
                this.pollTitles = polls.map((p) => p.title).join(', ');
                const days = polls
                    .map((p) => (p.closes_at ? Math.ceil((new Date(p.closes_at.replace(' ', 'T')).getTime() - Date.now()) / 86400000) : null))
                    .filter((d): d is number => d !== null);
                this.soonestDays = days.length ? Math.max(0, Math.min(...days)) : null;
            },
            error: () => { /* silently hide on error */ },
        });
    }
}
